import type { Lang } from '@/i18n/locale';
import type { FitnessPreferencesCopy } from '@/i18n/fitnessExperienceTypes';
import { requireFitnessExperienceCopy } from '@/i18n/translations';
export type { FitnessPreferencesCopy } from '@/i18n/fitnessExperienceTypes';

/** Synchronous after the shared locale boot/readiness boundary. */
export const getFitnessPreferencesCopy = (lang: Lang): FitnessPreferencesCopy => requireFitnessExperienceCopy(lang, 'preferences');
